<div id="cmsSectionList" class="clearfix {{titleColor}}" cdkDropList (cdkDropListDropped)="onDropCDKPromo($event)" *ngIf="newsletterInfoPromo">
    <div cdkDrag id="{{promo?.section_id}}" class="cms-default-promo cms-section clearfix" *ngFor="let promo of newsletterInfoPromo; let idx = index">
      <div class="cms-section-controls clearfix">
        <div class="cms-control-button section-clone">
          <a title="Clone/Copy this Section">
            <span>clone</span>
          </a>
        </div>
        <div class="cms-control-button section-delete">
          <span class="basic-icon delete-icon center-text"
            style="width: 23px; height: 23px; transform: translate(-50%, 8%);"
            (click)="deletePromo(promo)"></span>
        </div>
        <div class="cms-control-button section-move">
          <a title="Move this Section">
            <span>move</span>
          </a>
        </div>
        <div class="cms-control-button section-move-up" style="float: left;">
          <a title="Move this Section up" (click)="moveUp(promo)">
            <span>up</span>
          </a>
        </div>
        <div class="cms-control-button section-move-down" style="float: left;">
          <a title="Move this Section down" (click)="moveDown(promo)">
            <span>down</span>
          </a>
        </div>
        <div *ngIf="newletterToEditId == promo.section_id" class="create-loading">
          <mat-spinner diameter="20"></mat-spinner> {{addingTitle}}
        </div>
      </div>
      <div class="cms-collction-row two-column clearfix" style="display: flex;">
        <div class="cms-section-column">
          <div class="cms-head cms-editable-area">
            <h2 id="l_header" class="cms-editable-element" (click)="savePromoContent(promo?.l_header, promo, 'l_header')">
              {{promo?.l_header?promo?.l_header:"Promotion Name"}}
            </h2>
          </div>
          <div class="cms-block cms-block-img cms-editable-area" style="width: 240px; height: 145px;
                  float: right; text-align: center;" (click)="savePromoImage(promo, 'l_image')">
            <img id="l_image" class="cms-editable-element" [src]="promo?.l_image?'data:image/png;base64,' + promo?.l_image:'https://portal.dickerdata.com.au/resourcefiles/DickerData_Logo_BlackRed.png'"
              width="200" alt="" style="vertical-align: middle;" />
          </div>
          <div class="cms-block cms-block-heading cms-editable-area">
            <h3 id="l_promo_name" class="cms-editable-element" (click)="savePromoContent(promo?.l_promo_name, promo, 'l_promo_name')">
              {{promo?.l_promo_name?promo?.l_promo_name:"Heading"}}
            </h3>
          </div>
          <!-- cms-block-heading end -->
          <div class="cms-block cms-editable-area">
            <input class="example-full-width" placeholder="Description" (blur)="savePromoContent(promo?.l_description_01, promo, 'l_description_01')" [(ngModel)]="promo.l_description_01">
          </div>
          <div class="cms-block cms-editable-area">
            <input class="example-full-width" placeholder="Description" (blur)="savePromoContent(promo?.l_description_02, promo, 'l_description_02')" [(ngModel)]="promo.l_description_02">
          </div>
          <div class="cms-block cms-editable-area">
            <input class="example-full-width" placeholder="Description" (blur)="savePromoContent(promo?.l_description_03, promo, 'l_description_03')" [(ngModel)]="promo.l_description_03">
          </div>
          <div class="cms-block cms-editable-area">
            <input class="example-full-width" placeholder="Description" (blur)="savePromoContent(promo?.l_description_04, promo, 'l_description_04')" [(ngModel)]="promo.l_description_04">
          </div>
          <div class="cms-block cms-editable-area">
            <input class="example-full-width" placeholder="Description" (blur)="savePromoContent(promo?.l_description_05, promo, 'l_description_05')" [(ngModel)]="promo.l_description_05">
          </div>
          <div class="cms-block cms-editable-area">
            <input class="example-full-width" placeholder="Description" (blur)="savePromoContent(promo?.l_description_06, promo, 'l_description_06')" [(ngModel)]="promo.l_description_06">
          </div>
  
          <div class="cms-block cms-editable-area" (click)="savePromoArea(promo?.l_stock_code, promo, 'l_stock_code', idx)">
            <div id="l_stock_code" class="cms-editable-element">
              <table class="product-table" style="width: 170px;" cellspacing="0" cellpadding="0" border="0">
                <tr *ngIf="promo?.l_stk_valid != '1'" >
                  <td class="product-code">
                    <div class='left product-error'>
                      INVALID STOCK CODE
                    </div>
                  </td>
                </tr>
                <tr *ngIf="!promo?.l_stock_code || promo?.l_stk_valid == '1'">
                  <td class="product-code">
                    <div class='left' [class.stockCodeColor]="promo?.l_stock_code">
                      {{promo?.l_stock_code?promo?.l_stock_code:"Stock Code"}}
                    </div>
                  </td>
                </tr>
                <tr *ngIf="promo?.l_stk_valid == '1'" >
                  <td class="product-code">
                    <div class='right'>
                      {{promo?.l_current_price | currency:'AUD':'symbol-narrow':'.2-2'}} Ex Tax
                    </div>
                  </td>
                </tr>
                <tr *ngIf="promo?.l_stk_valid == '1'">
                  <td class="product-soh">
                    <div class='left'>
                      Stock: {{promo?.l_avail_stock_qty}}
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <!-- .cms-section-column ends -->
        <div class="cms-section-column">
          <div class="cms-head cms-editable-area">
            <h2 id="r_header" class="cms-editable-element" (click)="savePromoContent(promo?.r_header, promo, 'r_header')">
              {{promo?.r_header?promo?.r_header:"Promotion Name"}}
            </h2>
          </div>
          <div class="cms-block cms-block-img cms-editable-area" style="width: 240px; height: 145px;
                  float: right; text-align: center;" (click)="savePromoImage(promo, 'r_image')">
            <img id="r_image" class="cms-editable-element" [src]="promo?.r_image?'data:image/png;base64,' + promo?.r_image:'https://portal.dickerdata.com.au/resourcefiles/DickerData_Logo_BlackRed.png'"
              width="200" alt="" style="vertical-align: middle;" />
          </div>
          <div class="cms-block cms-block-heading cms-editable-area">
            <h3 id="r_promo_name" class="cms-editable-element" (click)="savePromoContent(promo?.r_promo_name, promo, 'r_promo_name')">
              {{promo?.r_promo_name?promo?.r_promo_name:"Heading"}}
            </h3>
          </div>
          <!-- cms-block-heading end -->
          <div class="cms-block cms-editable-area">
            <input class="example-full-width" placeholder="Description" (blur)="savePromoContent(promo?.r_description_01, promo, 'r_description_01')" [(ngModel)]="promo.r_description_01">
          </div>
          <div class="cms-block cms-editable-area">
            <input class="example-full-width" placeholder="Description" (blur)="savePromoContent(promo?.r_description_02, promo, 'r_description_02')" [(ngModel)]="promo.r_description_02">
          </div>
          <div class="cms-block cms-editable-area">
            <input class="example-full-width" placeholder="Description" (blur)="savePromoContent(promo?.r_description_03, promo, 'r_description_03')" [(ngModel)]="promo.r_description_03">
          </div>
          <div class="cms-block cms-editable-area">
            <input class="example-full-width" placeholder="Description" (blur)="savePromoContent(promo?.r_description_04, promo, 'r_description_04')" [(ngModel)]="promo.r_description_04">
          </div>
          <div class="cms-block cms-editable-area">
            <input class="example-full-width" placeholder="Description" (blur)="savePromoContent(promo?.r_description_05, promo, 'r_description_05')" [(ngModel)]="promo.r_description_05">
          </div>
          <div class="cms-block cms-editable-area">
            <input class="example-full-width" placeholder="Description" (blur)="savePromoContent(promo?.r_description_06, promo, 'r_description_06')" [(ngModel)]="promo.r_description_06">
          </div>
  
          <div class="cms-block cms-editable-area" (click)="savePromoArea(promo?.r_stock_code, promo, 'r_stock_code', idx)">
            <div id="r_stock_code" class="cms-editable-element">
              <table class="product-table" style="width: 170px;" cellspacing="0" cellpadding="0" border="0">
                <tr *ngIf="promo?.r_stk_valid != '1'" >
                  <td class="product-code">
                    <div class='left product-error'>
                      INVALID STOCK CODE
                    </div>
                  </td>
                </tr>
                <tr  *ngIf="!promo?.r_stock_code || promo?.r_stk_valid == '1'" >
                  <td class="product-code">
                    <div class='left' [class.stockCodeColor]="promo?.r_stock_code">
                      {{promo?.r_stock_code?promo?.r_stock_code:"Stock Code"}}
                    </div>
                  </td>
                </tr>
                <tr *ngIf="promo?.r_stk_valid == '1'" >
                  <td class="product-code">
                    <div class='right'>
                      {{promo?.r_current_price | currency:'AUD':'symbol-narrow':'.2-2'}} Ex Tax
                    </div>
                  </td>
                </tr>
                <tr *ngIf="promo?.r_stk_valid == '1'">
                  <td class="product-soh">
                    <div class='left'>
                      Stock: {{promo?.r_avail_stock_qty}}
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <!-- .cms-section-column ends -->
      </div>
      <!-- .cms-collction-row ends -->
    </div>
  </div>
  
  <app-newsletter-section-v2 [sendNewIdToSection]="sendNewIdToPromo" [newsletterEditViewModel]="newsletterEditViewModel" (editSectionEvent)="receiveEditSectionEvent($event)"></app-newsletter-section-v2>
  
  <div id="newsletterControls" class="clearfix" style="width:300px">
    <div id="cmsNewPromo" style=" float:left">
      <a *ngIf="!createLoading.promo" (click)="addPromo()">Add New Promo</a>
      <div *ngIf="createLoading.promo" class="create-loading">
        <mat-spinner diameter="20"></mat-spinner> Adding new promo...
      </div>
    </div>
    <div id="cmsNewSection" style="float:right">
      <a *ngIf="!createLoading.section" (click)="addSection()">Add New Section</a>
      <div *ngIf="createLoading.section" class="create-loading">
        <mat-spinner diameter="20"></mat-spinner> Adding new section...
      </div>
      
    </div>
  </div>
